import * as React from 'react';
import clsx from 'classnames';

function SvgPerson({className, ...props}) {
    return (
        <svg width={14} height={14} fill="none" className={clsx('text-font-tertiary', className)} {...props}>
            <path
                d="M4.75 11.188c.792.416 1.542.624 2.25.624s1.448-.208 2.219-.624c.791-.417 1.385-.928 1.781-1.532-.02-.583-.49-1.073-1.406-1.469-.917-.395-1.781-.593-2.594-.593s-1.677.198-2.594.593c-.916.376-1.385.865-1.406 1.47.396.603.98 1.114 1.75 1.53zm3.656-8.25A1.922 1.922 0 007 2.344c-.542 0-1.01.198-1.406.594A1.922 1.922 0 005 4.343c0 .541.198 1.01.594 1.406.396.396.864.594 1.406.594.542 0 1.01-.198 1.406-.594.396-.396.594-.865.594-1.406 0-.542-.198-1.01-.594-1.407zm-6.125-.626C3.594 1 5.167.345 7 .345c1.833 0 3.396.656 4.688 1.969C13 3.603 13.655 5.167 13.655 7c0 1.833-.656 3.406-1.969 4.719C10.396 13.01 8.834 13.656 7 13.656c-1.833 0-3.406-.646-4.719-1.937C.99 10.406.344 8.833.344 7c0-1.833.646-3.396 1.937-4.688z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SvgPerson;
